import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login, requestPasswordReset } from "../api/client";
import { useAuth } from "../context/AuthContext";
import BackgroundAnimation from "../components/BackgroundAnimation";
import "../auth.css";

export default function Login() {
  const { saveAuth } = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]       = useState({ email: "", password: "" });
  const [error, setError]     = useState("");
  const [info, setInfo]       = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.email || !form.password) { setError("All fields required"); return; }
    setLoading(true); setError(""); setInfo("");
    try {
      const data = await login(form);
      saveAuth(data);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const handleForgotPasswordShortcut = async () => {
    if (!form.email.trim()) {
      setError("Please enter your registered email address in the Email field first, then click 'Forgot Password?'.");
      return;
    }
    setLoading(true);
    setError("");
    setInfo("");
    try {
      const data = await requestPasswordReset({ email: form.email.trim() });
      setError("");
      setInfo(data.message || "A recovery password reset link has been successfully sent to your email!");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to send reset link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <BackgroundAnimation />
      <div className="auth-card">
        <div className="auth-brand">
          TV<span className="accent">→</span>MT5
        </div>
        <div className="auth-title">
          Welcome back
        </div>
        <div className="auth-sub">
          Sign in to your bridge account
        </div>

        {error && (
          <div className="auth-error">{error}</div>
        )}

        {info && (
          <div className="auth-info" style={{ color: "var(--green)", background: "rgba(16, 185, 129, 0.08)", border: "1px solid rgba(16, 185, 129, 0.2)", padding: "10px", borderRadius: "var(--radius)", fontSize: "13px", marginBottom: "16px", fontWeight: "500", textAlign: "center" }}>
            {info}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-input"
            placeholder="you@example.com"
            value={form.email}
            onChange={e => setForm(p => ({...p, email: e.target.value}))}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
          />
        </div>

        <div className="form-group">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <label className="form-label">Password</label>
            <span
              onClick={handleForgotPasswordShortcut}
              style={{ fontSize: "12px", color: "var(--accent)", textDecoration: "none", cursor: "pointer", fontWeight: "600" }}
            >
              Forgot Password?
            </span>
          </div>
          <input
            type="password"
            className="form-input"
            placeholder="••••••••"
            value={form.password}
            onChange={e => setForm(p => ({...p, password: e.target.value}))}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width: "100%", marginTop: 8 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        <div className="auth-footer">
          Don't have an account?{" "}
          <Link to="/signup">Sign up</Link>
        </div>
      </div>
    </div>
  );
}
